import 'css-chunksrc/client/scenes/milestoneCompletion/styles.scss';export default {
  "header": "_header_zfj7z_1",
  "title": "_title_zfj7z_5",
  "main": "_main_zfj7z_11",
  "buttons": "_buttons_zfj7z_21",
  "confirmButton": "_confirmButton_zfj7z_31"
};